import * as Sentry from '@sentry/browser'
import { detectEnvironmentFromUrl, Environment } from 'shared/config/config'

/**
 * Capture exceptions to Sentry only in production environment
 * Similar to captureEvent.ts pattern for analytics
 */
export function captureException(error: any, context: string, extra: Record<string, any> = {}) {
  if (detectEnvironmentFromUrl() !== Environment.PRODUCTION) {
    // eslint-disable-next-line no-console
    console.log(`[DEV] Would capture exception to Sentry:`, {
      context,
      error: error instanceof Error ? error.message : String(error),
      extra,
    })
    return
  }

  // Only capture to Sentry in production
  Sentry.captureException(error, {
    extra: {
      context,
      ...extra,
    },
  })
}

/**
 * Capture messages to Sentry only in production environment
 * Useful for non-error logging that still needs to go to Sentry
 */
export function captureMessage(
  message: string,
  context: string,
  extra: Record<string, any> = {},
  level: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' = 'info'
) {
  if (detectEnvironmentFromUrl() !== Environment.PRODUCTION) {
    // eslint-disable-next-line no-console
    console.log(`[DEV] Would capture message to Sentry:`, {
      context,
      message,
      level,
      extra,
    })
    return
  }

  // Only capture to Sentry in production
  Sentry.captureMessage(message, {
    level,
    extra: {
      context,
      ...extra,
    },
  })
}
